import { getDomainNameFromTeamExternalIntegration } from 'components/status-checks/status-checks-form-utils'

import type {
  StatusCheckTeamExternalIntegration,
  TeamExternalIntegration
} from 'types/api/status-checks/status-check'

/**
 * Returns status check related URLs.
 */
export function getStatusChecksUrls() {
  const statusChecksBaseUrl = '/configurations/health-checks'

  return {
    authentication: () => `${statusChecksBaseUrl}/authentication`,
    base: () => statusChecksBaseUrl,
    edit: (statusCheckId: string) =>
      `${statusChecksBaseUrl}/edit/${statusCheckId}`,
    editAuthenticationFromTeamExternalIntegration: (
      integration: TeamExternalIntegration | StatusCheckTeamExternalIntegration
    ) => {
      const domainName = getDomainNameFromTeamExternalIntegration(integration)
      return `${statusChecksBaseUrl}/edit/authentication/${encodeURI(
        integration.name
      )}/${integration.observabilityToolType}${domainName}`
    },
    list: () => `${statusChecksBaseUrl}/list`,
    new: () => `${statusChecksBaseUrl}/new`,
    newAuthentication: () => `${statusChecksBaseUrl}/new/authentication`
  }
}
